import { Client as FeatureGateClient } from './client/Client';

export default FeatureGateClient;
